import { render, staticRenderFns } from "./RequestAllocations.vue?vue&type=template&id=e94b42cc&"
import script from "./RequestAllocations.vue?vue&type=script&lang=ts&"
export * from "./RequestAllocations.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports